@use "/src/styles/functions";

.container {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: functions.space(12);
  width: 100%;
  padding-bottom: functions.space(20);
}

.button {
  min-width: functions.toRem(120);
}
